import { useLayoutEffect, useState } from "react";

import type { breakpoints } from "@eisox/tokens";

interface UseMediaQueryOptions {
  defaultValue?: boolean;
  initializeWithValue?: boolean;
}

const useMediaQuery = (
  query: `(${"min" | "max"}-width: ${(typeof breakpoints)[keyof typeof breakpoints]}px)`,
  { defaultValue = false, initializeWithValue = true }: UseMediaQueryOptions = {},
): boolean => {
  const [matches, setMatches] = useState<boolean>(() => {
    if (initializeWithValue) {
      return window.matchMedia(query).matches;
    }
    return defaultValue;
  });

  useLayoutEffect(() => {
    const matchMedia = window.matchMedia(query);

    const handleChange = () => {
      setMatches(matchMedia.matches);
    };

    handleChange();

    matchMedia.addEventListener("change", handleChange);

    return () => {
      matchMedia.removeEventListener("change", handleChange);
    };
  }, [query]);

  return matches;
};

export { useMediaQuery };
